import React, { useEffect, useRef } from 'react';
// Constants
import { CompanyName, KeywordsPages } from '../../utils/Constants';
// Data
import {
  sessionsPageAdditionalMeta,
  sessionsPageStructuredData,
} from '../../utils/data/MetaData';
// Images
import MainImage from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-vibrant-ass.jpg';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import SessionsPageMainContainer from '../../components/sessions/SessionsPageMainContainer';
// Videos
import MainVideo from '../../assets/videos/liyah-minx-bbw-ebony-dominatrix-femdom-main-video-tease.mp4';

function SessionsPage() {
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && videoRef.current) {
          videoRef.current.play().catch((e) => {
            // Handle auto-play restrictions (e.g., user hasn't interacted yet)
            console.log('Autoplay failed:', e);
          });
        }
      },
      { threshold: 0.5 } // Adjust as needed
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) observer.unobserve(videoRef.current);
    };
  }, []);
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Sessions'
        desc={`Experience the ultimate submission with ${CompanyName}. Explore My session offerings, tributes, and the privileges that await those who dare to serve.`}
        keywords={KeywordsPages}
        additionalMeta={sessionsPageAdditionalMeta}
        structuredData={sessionsPageStructuredData}
      />

      {/* Page */}
      <div className='grid relative min-h-screen font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        {/* Main */}
        <div className='grid'>
          {/* Navigation */}
          <Navbar />
          <header className='grid w-full h-fit'>
            <section className='grid px-8 pt-20'>
              <h1 className='text-center font-titleFont text-5xl lg:text-7xl text-colour7  tracking-widest'>
                Sessions
              </h1>
              <h2 className='tracking-wider mt-2 text-center font-t font-bold text-xl underline underline-offset-4'>
                Join Me online or in person
              </h2>
              <section className='grid mt-8'>
                <div className='z-10 px-8 xs:px-10 xs:py-5'>
                  <img
                    src={MainImage}
                    alt={`${CompanyName} with neon diamond logo`}
                    className='mx-auto sm:max-w-[60vw] md:max-h-[60vh] rounded neon_shadow'
                    loading='lazy'
                  />
                </div>
              </section>
              <p className='text-center text-lg mt-6 max-w-3xl mx-auto'>
                I offer a variety of seductive, intense, and unforgettable
                sessions — both online and in person. Whether you crave control,
                worship, or deep exploration of your kinkiest desires, I tailor
                each experience to leave you aching for more. Come prepared to
                surrender.
              </p>

              {/* New location and travel info */}
              <p className='text-center text-md mt-4 max-w-3xl mx-auto italic text-colour7'>
                I am based in central Indiana, and also service the surrounding
                states. FMTY is available if you wish for me to come to you. All
                travel expenses are the responsibility of the sub!
              </p>

              <p className='text-center text-md mt-4 max-w-3xl mx-auto italic text-colour7'>
                For sessions, an early morning fee will be applied to any
                sessions before 12 noon. $55 fee. I do online play and am
                usually up late typical until 1a~3a. Therefore, I don’t like to
                do early morning sessions. Please be advised.{' '}
              </p>
            </section>

            <section className='grid mt-8'>
              <div className='z-10 px-8 xs:px-10 xs:py-5'>
                <video
                  ref={videoRef}
                  controls
                  className='w-fit mx-auto max-h-[32rem] object-contain' // 32rem = h-128 = 512px, adjust as needed
                  muted
                  preload='none'
                  playsInline
                  src={`${MainVideo}#t=0.001`}
                />
              </div>
            </section>
          </header>

          {/* Main page content */}
          <SessionsPageMainContainer />
        </div>
      </div>
    </>
  );
}

export default SessionsPage;
